import React, { useRef, useState } from "react";
import Controls from "./Controls";
import Details from "./Details";
import Header from "./Header";

export default function Main({ playing, setPlaying,showSidebar, currentSong, prevSong,nextSong }) {
  const player = useRef(null);


  const changeVol = (volume) => {
    player.current.volume = volume;
  };

  const startSong = () => {
    setPlaying(true);
    player.current.play();

  };
  const stopSong = () => {
    setPlaying(false);
    player.current.pause();
  };

  const songEnded=()=>{
    setPlaying(false)
    nextSong()
  }

  return (
    <div className="main">
      <Header showSidebar={showSidebar} />
      <div className="image">
        <img src={currentSong.img} alt={currentSong.name} />
      </div>
      <Details name={currentSong.name} desc={currentSong.desc} />
      <Controls
        currentSong={currentSong}
        playing={playing}
        startSong={startSong}
        stopSong={stopSong}
        prevSong={prevSong}
        nextSong={nextSong}
        changeVol={changeVol}
      />
      <audio ref={player} src={currentSong.song} controls autoPlay onEnded={()=>songEnded()} />
    </div>
  );
}
